import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Dialog, LinkButton } from 'rc-easyui';


import { setStatusValue } from '../../actions/Project/ProjectListAction';

import { setIsShowFindAllViewList} from '../../actions/transOperationActions';
import { showHideFrameList,updateFindFrameTargetData} from '../../actions/find/frameFindAction';

import { setIsShowFindAllViewInput,setIsShowFindAllViewReplace} from '../../actions/transOperation_find_Actions';
import { showFrameSplitError} from '../../actions/findActions';
import styled from "styled-components";
import {Popup} from "semantic-ui-react";


class FrameSplitView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value:11,
            errors: {},
            isShowCreate:false,
            isShowFindForm:false,
            frameNumber:this.props.context.findFrameSplitValue,
            DialogHeight:300,

            //設定間隔
            findFrameSplitValue:this.props.context.findFrameSplitValue

        };
        this.closefindAllView_input = this.closefindAllView_input.bind(this);
        this.closefindAllView_list = this.closefindAllView_list.bind(this);
        this.closefindAllView_replace = this.closefindAllView_replace.bind(this);
        this.setShowCreate = this.setShowCreate.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
    }

    async closeDialog() {
        this.props.showFrameSplitError(false);
    }


    async componentDidMount() {
        let height = window.innerHeight - 500;

        await this.setState({ DialogHeight: height });
        await this.setState({ value: this.props.project.statusValue });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            this.setState({ errors: nextProps.errors });
        }

        // if (nextProps.findOperation) {
        //     const isShowFrameSplitError = nextProps.findOperation.isShowFrameSplitError;
        //     if(isShowFrameSplitError === true){
        //         this.dlg.open();
        //     }
        //     this.setState({ findFrameSplitValue: nextProps.findOperation.findFrameSplitValue });
        //
        // }

        if (nextProps.context.findFrameSplitValue !== this.state.findFrameSplitValue) {
            this.setState({ findFrameSplitValue: nextProps.context.findFrameSplitValue });
        }
    }


    async setShowCreate(result) {
        await this.setState({ isShowCreate:result });
    }

    async setShowFindForm(result) {
        await this.setState({ isShowFindForm:result });
    }


    async closefindAllView_input() {
        this.props.setIsShowFindAllViewInput(false);
    }

    async closefindAllView_list() {
        this.props.setIsShowFindAllViewList(false);

    }
    async closefindAllView_replace() {
        this.props.setIsShowFindAllViewReplace(false);
    }

    render() {
        const { videoFps } = this.props.transOperation;
        const {data} = this.props.editTable;
        const {frameNumber} = this.state;

        let mainContent;

        return (<div
            title="Find Frame Split"
            style={{width:'450px'  }}
            ref={ref=>this.dlg=ref}
        >
            <h3>Find Frame Split</h3>
            <form  className=' '  >
                <div className="form-group">
                    <label htmlFor="inputAddress">Enter Frame Split Value to Check: :</label>
                    <input type="text" className="form-control" id="inputAddress" placeholder=" "
                           style={{width:'350px'  }}
                           value={this.state.findFrameSplitValue}
                           onChange={async (event) => {

                               if(event.target.value !== ""){
                                   //往上更新數值
                                   this.props.context.setfindFrameSplitValue(event.target.value);
                               }

                               await this.setState({ findFrameSplitValue: event.target.value });

                           }}
                    />
                </div>
                <div style={{marginBottom:'20px'}}>
                    <LinkButton onClick={() => {

                        //開始搜尋
                        this.props.updateFindFrameTargetData(data,videoFps,parseFloat(this.props.context.findFrameSplitValue));

                        //關掉視窗
                        this.props.showHideFrameList(true);

                        this.closeDialog(true);

                    }} >Confirm</LinkButton>
                </div>
            </form>


            <hr/>
            <div className=' '>
                <LinkButton style={{ width: 80 }} onClick={() => this.closeDialog(true)}  >Close</LinkButton>
            </div>
        </div>);
    }
}


FrameSplitView.propTypes = {
    errors: PropTypes.object.isRequired,
    project: PropTypes.object.isRequired,
    setIsShowFindAllViewInput: PropTypes.func.isRequired,
    multipleFind: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    project: state.project,
    errors: state.errors,
    transOperation: state.transOperation,
    findOperation: state.findOperation,
    editTable: state.editTable
});

export default connect(mapStateToProps, {updateFindFrameTargetData, showHideFrameList,setStatusValue,setIsShowFindAllViewInput,setIsShowFindAllViewList ,setIsShowFindAllViewReplace,showFrameSplitError})(
    withRouter(FrameSplitView)
);



// WEBPACK FOOTER //
// ./src/components/multipleFind/FrameSplitView.js